// Dynamically import package.json to get version at build time
// This ensures version is always in sync with package.json without needing .env files

import packageJson from '../../package.json';

export const VERSION = packageJson.version;
